import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  private socket: Socket;
  private isListeningToExpedienteChange = false;

  constructor() {
    this.socket = io(environment.apiUrl, {
      withCredentials: true,
    });
  }

  listenToExpedienteChanges(
    callback: (data: { radicado: string; action: string }) => void
  ): void {
    if (!this.isListeningToExpedienteChange) {
      this.isListeningToExpedienteChange = true;
      this.socket.on('expediente-change', callback);
    }
  }

  disconnect(): void {
    if (this.socket) {
      this.socket.disconnect();
      this.isListeningToExpedienteChange = false;
    }
  }
}
